(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabRequisitionConsent', LabRequisitionConsent);

    LabRequisitionConsent.$inject = ['$resource'];

    function LabRequisitionConsent ($resource) {
        var resourceUrl =  'api/lab-requisition-consents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/lab-requisition-consents/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
